module.exports = __webpack_public_path__ + "static/media/PC官网高分辨率.5c9aeb6.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/PC官网高分辨率.mp4
// module id = C7OR
// module chunks = 1